import { render, staticRenderFns } from "./pastSubscriptionDetails.vue?vue&type=template&id=2ccb4f90&"
import script from "./pastSubscriptionDetails.vue?vue&type=script&lang=js&"
export * from "./pastSubscriptionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports